import axios, { AxiosResponse } from 'axios';

import { CONFIG } from '@/config/config.ts';

import { HTTP_STATUS } from './ErrorCode.model';
import { HTTP_HEADER } from './httpHeaders.model';
import { maintenanceErrorInterceptor } from './maintenanceInterceptor.util';

const successfulResponseHandler = (response: AxiosResponse): AxiosResponse => {
  if (response.status === HTTP_STATUS.REDIRECT) {
    delete response.headers[HTTP_HEADER['X-CSRF-Token']];
  }

  return response;
};

type Return = ReturnType<typeof axios.create>;

const createAxiosInstance = (): Return => {
  const axiosInstance = axios.create();

  axiosInstance.interceptors.response.use(successfulResponseHandler);
  axiosInstance.interceptors.response.use(res => res, maintenanceErrorInterceptor);
  axiosInstance.interceptors.request.use(config => {
    if (CONFIG.ENVIRONMENT === 'local') {
      config.headers['x-auth-token'] = `${CONFIG.JSESSION}`;
    }
    return config;
  });

  return axiosInstance;
};

export const sharedAxiosInstance = createAxiosInstance();

// eslint-disable-next-line @eslint-react/no-unnecessary-use-prefix -- kept as a hook-shaped API for existing call sites
export const useAxiosInstance = (): Return => sharedAxiosInstance;
